import React from "react";
import { RefundableRoomDetailsV2 } from "halifax";

type RefundableRoomDetailsV2Props = React.ComponentProps<
  typeof RefundableRoomDetailsV2
>;

type PartialRefundableRoomDetailsV2Props = Pick<
  RefundableRoomDetailsV2Props,
  | "setRefundableRoomProduct"
  | "setOpenRefundableRoomDetails"
  | "isMobile"
  | "checkInDate"
  | "checkInTime"
  | "isXmodRedesign"
>;

type RemainingRefundableRoomDetailsV2Props = Omit<
  RefundableRoomDetailsV2Props,
  keyof PartialRefundableRoomDetailsV2Props
>;

export const createCustomRefundableRoomDetailsV2 =
  ({
    setRefundableRoomProduct,
    setOpenRefundableRoomDetails,
    isMobile,
    checkInDate,
    checkInTime,
    isXmodRedesign,
  }: PartialRefundableRoomDetailsV2Props) =>
  ({
    roomProduct,
    roomInfoProduct,
    setRoomInfoProduct,
    roomProductIndex,
    setRoomProductIndex,
    hotelBaseRelativeRate,
    displayRefundableRoomBulletPoints,
    displayTaxesAndFeesIncluded,
    nightCount,
  }: RemainingRefundableRoomDetailsV2Props) =>
    (
      <RefundableRoomDetailsV2
        roomProduct={roomProduct}
        roomInfoProduct={roomInfoProduct}
        setRoomInfoProduct={setRoomInfoProduct}
        roomProductIndex={roomProductIndex}
        setRoomProductIndex={setRoomProductIndex}
        hotelBaseRelativeRate={hotelBaseRelativeRate}
        displayRefundableRoomBulletPoints={displayRefundableRoomBulletPoints}
        checkInDate={checkInDate}
        checkInTime={checkInTime}
        setRefundableRoomProduct={setRefundableRoomProduct}
        setOpenRefundableRoomDetails={setOpenRefundableRoomDetails}
        isMobile={isMobile}
        isXmodRedesign={isXmodRedesign}
        displayTaxesAndFeesIncluded={displayTaxesAndFeesIncluded}
        nightCount={nightCount}
      />
    );
